import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  visits_dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: token.colorError
  }
}))
